import {DiagnosticReportId} from '@legit.health/ui';
import postMessageToParent from './postMessageToParent';

export default function postAnalysisCompletedMessage(diagnosticReportId: DiagnosticReportId) {
  postMessageToParent({
    message: 'analysis_completed',
    id: diagnosticReportId,
    payload: {
      id: diagnosticReportId
    }
  });
}
